<template>
  <div class="tab">
    <el-footer v-if="showManageFooter" class="tab__footer page__active_bar">
      <el-button
        v-if="$can('update', 'dvr_servers')"
        :loading="loading"
        class="page__active_button"
        type="success"
        icon="el-icon-check"
        @click="onSave"
      >
        Сохранить
      </el-button>
      <el-button
        v-if="$can('update', 'cameras_dvr_server')"
        :loading="loading"
        class="page__active_button"
        type="primary"
        @click="dialogDvr = true"
      >
        Перенести камеры
      </el-button>
      <el-button
        v-if="$can('update', 'cameras_dvr_server')"
        :loading="loading"
        class="page__active_button"
        type="primary"
        :disabled="!server.cameras_count > 0"
        @click="dialogReserve = true"
      >
        Резервный перенос
      </el-button>
      <el-button
        v-if="$can('delete', 'dvr_servers')"
        :loading="loading"
        class="page__active_button"
        type="danger"
        icon="el-icon-delete"
        @click="onDelete"
      >
        Удалить сервер
      </el-button>
    </el-footer>
    <main class="page_container">
      <el-form ref="form" label-position="top" :model="form" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="server_domain" label="Имя">
              <el-input size="small" v-model="form.server_domain" :readonly="!$can('update', 'dvr_servers')" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Режим сервера" prop="id_server_mode">
              <select-servers-mode v-if="$can('update', 'dvr_servers')" v-model="form.id_server_mode" />
              <el-input v-else readonly :value="form.server_mode_name" size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="Максимальное количество камер" prop="max_cameras_count">
              <el-input-number
                v-model="form.max_cameras_count"
                size="small"
                :min="0"
                :max="5000"
                :disabled="!$can('update', 'dvr_servers')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Размер хранилища [ТБ]" prop="archive_size">
              <el-input-number
                v-model="form.archive_size"
                size="small"
                :min="0"
                :max="5000"
                :disabled="!$can('update', 'dvr_servers')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Чистить архивы" prop="clean_archive">
              <el-switch
                v-model="form.clean_archive"
                :active-value="1"
                :inactive-value="0"
                :disabled="!$can('update', 'dvr_servers')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="Версия ПО">
              <el-input size="small" readonly :value="server.server_version" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Камер на сервере">
              <el-input v-if="server.cameras_count !== null" size="small" readonly :value="server.cameras_count" />
              <strong v-else>Нет данных</strong>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col v-if="isAdmin" :span="12" class="server-edit__fat-agent">
            <el-form-item label="Толстый агент" prop="is_new_agent">
              <el-switch
                v-model="isNewAgent"
                :active-value="1"
                :inactive-value="0"
                :disabled="!canChangeNewAgent"
              />
              <span
                v-if="!canChangeNewAgent"
                class="server-edit__fat-agent-reason"
              >
                {{ newAgentDenyReason }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="API-ключ AVC панели" prop="avc_panel_api_key">
              <el-input v-model="form.avc_panel_api_key" size="small" placeholder="api_key" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Группа серверов" prop="id_server_group">
              <template slot="label">
                Группа серверов
                <el-tooltip class="item" effect="light" placement="top-start">
                  <template slot="content">
                    Группа влияет на <code>rules.conf</code> сервера. Оставить пустым для настроек по умолчанию
                  </template>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <el-select
                v-model="form.id_server_group"
                size="small"
                placeholder="Нет группы"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="val in serverGroups"
                  :key="val.id_server_group"
                  :label="val.server_group_name"
                  :value="val.id_server_group"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div v-if="$can('update', 'cameras_dvr_server') && activeTransfers.length > 0">
        <h3>Возврат камер на свои сервера</h3>
        <el-switch
          v-model="forceReturn"
          active-text="Принудительно"
          :active-value="1"
          :inactive-value="0"
          style="padding: 10px 10px"
        />
        <div class="buttons__wrapper">
          <el-button
            v-for="transfer in activeTransfers"
            :key="transfer.id_reserve_transfer"
            :loading="isReturnButtonLoading"
            class="page__active_button"
            type="primary"
            @click="() => handleReturnCamerasButton(transfer)"
          >
            Вернуть на {{ transfer.server_name }}
          </el-button>
        </div>
      </div>
    </main>
    <dvr-server-dialog
      :id-server="newCamerasDvrServer || server.id"
      :visible="dialogDvr"
      :loading="camerasMoveLoading"
      confirm-button-text="Перенести"
      @close="dialogDvr = false"
      @save="onMoveCameras"
    />
    <reserve-server-dialog
      :id-server="newCamerasDvrServer || server.id"
      :visible="dialogReserve"
      :loading="camerasMoveLoading"
      confirm-button-text="Перенести"
      @close="dialogReserve = false"
      @save="onMoveCamerasReserve"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { required, length } from "@/core/helpers/validators";
import SelectServersMode from "@/components/Server/feature/SelectServersMode";
import { ApiService } from "@/api";
import DvrServerDialog from "@/components/Server/feature/DvrServerDialog";
import ReserveServerDialog from "@/components/Server/feature/ReserveServerDialog";
import { checkPermission } from "@/core/helpers/permissions";

const newAgentChangeReasons = {
  has_cameras: "Нельзя изменить, пока на сервере есть камеры",
};

export default {
  name: "ServerEdit",
  components: { DvrServerDialog, ReserveServerDialog, SelectServersMode },
  props: {
    getServerData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      camerasMoveLoading: false,
      dialogDvr: false,
      dialogReserve: false,
      newCamerasDvrServer: null,
      isReturnButtonLoading: false,
      forceReturn: 0,
      isNewAgent: 0,
      savedIsNewAgent: 0,
      serverGroups: [],
      activeTransfers: [],
      form: {
        server_domain: "",
        max_cameras_count: null,
        archive_size: null,
        clean_archive: null,
        id_server_mode: null,
        avc_panel_api_key: "",
        id_server_group: null,
      },
      rules: this.$can("update", "dvr_servers")
        ? {
            server_domain: [required(), length(3, 100)],
            max_cameras_count: [required("number")],
            archive_size: [required("number")],
            clean_archive: [required("number")],
            id_server_mode: [required("number")],
          }
        : null,
    };
  },
  computed: {
    ...mapState("server", {
      server: (state) => state.server,
    }),
    ...mapState("profile", {
      profile: (state) => state.profile,
    }),
    isAdmin() {
      return Boolean(this.profile && this.profile.data && this.profile.data.is_admin);
    },
    canChangeNewAgent() {
      return this.server.is_new_agent_can_change === 1;
    },
    newAgentDenyReason() {
      return newAgentChangeReasons[this.server.is_new_agent_change_reason] || "Нельзя изменить, пока на сервере есть камеры";
    },
    showManageFooter() {
      const footerPermissions = ["dvr_servers:update", "dvr_servers:delete", "cameras_dvr_server:update"];
      return footerPermissions.some((permission) => checkPermission(permission));
    },
  },
  watch: {
    server(newServer) {
      const availableFields = Object.keys(this.form);
      availableFields.forEach((key) => {
        this.form[key] = newServer[key];
      });
      this.isNewAgent = newServer.is_new_agent;
      this.savedIsNewAgent = newServer.is_new_agent;
      this.activeTransfers = newServer.active_transfers || [];
    },
  },
  created() {
    this.getServerGroups()
      .then((res) => {
          this.serverGroups = res
        }
      );
  },
  methods: {
    ...mapActions("server", {
      updateServer: "UPDATE_SERVER",
      updateServerIsNewAgent: "UPDATE_SERVER_IS_NEW_AGENT",
      getServer: "GET_SERVER",
      getServerGroups: "GET_SERVER_GROUPS",
      returnCameras: "RETURN_CAMERAS",
    }),
    onDelete() {
      // ТЗ 1.3: подтверждение с красной «Удалить» и зелёной «Отменить».
      this.$confirm("Вы точно хотите удалить сервер?", "Удаление сервера", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отменить",
        confirmButtonClass: "el-button--danger",
        cancelButtonClass: "el-button--success",
        type: "warning",
      })
        .then(this.delete)
        .catch(() => {});
    },
    delete() {
      this.loading = true;
      return ApiService.servers
        .delete(this.server.id)
        .then(() => {
          this.$router.push({ name: "servers", params: { page: 1 } });
          this.$message({
            message: "Сервер удалён",
            type: "success",
          });
        })
        .catch((e) => {
          // Причину отказа присылает бэк: «на сервере есть камеры»,
          // «на сервере есть валидный архив» (ТЗ 1.3).
          this.$message({
            message: (e.response && e.response.data.error) || "Неизвестная ошибка",
            type: "error",
          });
        })
        .finally(() => (this.loading = false));
    },
    onSave() {
      let isValidate;
      this.$refs["form"].validate((status) => {
        isValidate = status;
      });

      if (!isValidate) return false;

      this.loading = true;
      const getErrorMessage = (error) =>
        (error.response && error.response.data && error.response.data.error) || "Неизвестная ошибка";
      const requestResult = (name, request) =>
        request.then(
          () => ({ name }),
          (error) => ({ name, error })
        );
      const requests = [
        requestResult("Настройки сервера", this.updateServer({ id: this.server.id, newServer: this.form })),
      ];
      const newAgentValue = this.isNewAgent;

      if (newAgentValue !== this.savedIsNewAgent) {
        requests.push(
          requestResult(
            "Признак «Толстый агент»",
            this.updateServerIsNewAgent({ id: this.server.id, isNewAgent: newAgentValue }).then(() => {
              this.savedIsNewAgent = newAgentValue;
            })
          )
        );
      }

      Promise.all(requests)
        .then((results) => {
          const failed = results.filter((result) => result.error);

          if (failed.length) {
            const saved = results.filter((result) => !result.error).map((result) => result.name);
            const errors = failed.map((result) => {
              return `${result.name}: ${getErrorMessage(result.error)}`;
            });

            this.$message({
              message: `${saved.length ? `Сохранено: ${saved.join(", ")}. ` : ""}Не сохранено: ${errors.join("; ")}`,
              type: "error",
            });
            return;
          }

          this.$message({
            message: "Данные успешно обновлены",
            type: "success",
          });
        })
        .catch((e) => {
          this.$message({
            message: getErrorMessage(e),
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onMoveCameras(newServerId, force) {
      if (newServerId === this.server.id) {
        return this.$message.error("Новый сервер должен отличаться от текущего");
      }

      this.camerasMoveLoading = true;
      ApiService.servers
        .moveCameras(this.server.id, newServerId, force)
        .then(() => {
          this.$message.success("Камеры успешно перенесены");
        })
        .catch((e) => {
          this.$message.error(e.response.data.error || "Произошла ошибка при переносе камер");
        })
        .finally(() => {
          this.camerasMoveLoading = false;
        });
    },
    onMoveCamerasReserve(newServerId, force) {
      if (newServerId === this.server.id) {
        return this.$message.error("Новый сервер должен отличаться от текущего");
      }

      this.camerasMoveLoading = true;
      ApiService.servers
        .moveCamerasReserve(this.server.id, newServerId, force)
        .then(() => {
          this.$message.success("Камеры успешно перенесены");
        })
        .catch((e) => {
          this.$message.error(e.response.data.error || "Произошла ошибка при переносе камер");
        })
        .finally(() => {
          this.camerasMoveLoading = false;
        });
    },
    handleReturnCamerasButton(transfer) {
      this.$confirm(
        `Вернуть камеры на сервер ${transfer.server_name}`,
        "Возврат камер",
        {
          confirmButtonText: "Вернуть",
        }
      )
        .then(() => {
          this.isReturnButtonLoading = true;

          this.returnCameras({ id: transfer.id_reserve_transfer, force: this.forceReturn })
            .then(() => {
              this.$message({
                message: 'Камеры возвращены',
                type: 'success',
              });
              this.getServerData();
            })
            .catch((e) => {
              this.$message({
                type: "error",
                message: e.response.data.error || "Неизвестная ошибка",
              });
            });
        })
        .finally(() => { this.isReturnButtonLoading = false });
    },
  },
};
</script>

<style>
.buttons__wrapper {
  display: flex;
  flex-direction: column;
  width: 450px;
  margin-bottom: 10px;
}
.server-edit__fat-agent-reason {
  margin-left: 10px;
  color: #606266;
}
</style>
